// Snowflake Effect
// Extracted from theme.js for better organization

window.theme = window.theme || {};

theme.SnowflakeEffect = (function () {
  var config = {
    maxFlakes: 80,
    minSize: 10,
    maxSize: 16,
    minOpacity: 0.4,
    maxOpacity: 0.55,
    minFallDuration: 4, // seconds - slower = longer duration
    maxFallDuration: 8,
    container: null,
    snowflakeImage: null,
    flakes: [],
  };

  function createSnowflake() {
    var flake = document.createElement("img");
    flake.src = config.snowflakeImage;
    flake.className = "snowflake";

    var size =
      Math.random() * (config.maxSize - config.minSize) + config.minSize;
    var opacity =
      Math.random() * (config.maxOpacity - config.minOpacity) +
      config.minOpacity;
    var startX = Math.random() * 100;

    // Each flake gets unique animation properties
    var fallDuration =
      Math.random() * (config.maxFallDuration - config.minFallDuration) +
      config.minFallDuration;
    var fallDelay = Math.random() * 2; // Stagger start times

    // Calculate fall distance (header height + buffer)
    var containerHeight = config.container.offsetHeight || 100;
    var fallDistance = containerHeight + 50;

    // Rotation properties - increased rotation
    var rotationDirection = Math.random() > 0.5 ? 1 : -1; // Random clockwise or counterclockwise
    // Increased rotation - 60-180 degrees total during the entire fall
    var rotationAmount = Math.random() * 120 + 60; // 60-180 degrees
    var rotationEnd = rotationDirection * rotationAmount;

    // Horizontal movement - only for some flakes (50% chance)
    var hasHorizontalMovement = Math.random() > 0.5;
    var horizontalDirection = 0; // 0 = no movement, 1 = right, -1 = left
    var horizontalAmount = 0;
    if (hasHorizontalMovement) {
      horizontalDirection = Math.random() > 0.5 ? 1 : -1; // Set direction at start
      horizontalAmount = Math.random() * 8 + 5; // 5-13px total horizontal drift - very slight
    }

    // Calculate keyframe positions for smooth animation
    var keyframePositions = [];
    for (var i = 0; i <= 8; i++) {
      var progress = i / 8;
      var yPos = fallDistance * progress;

      // Calculate horizontal drift (linear progression in one direction)
      var xPos = 0;
      if (hasHorizontalMovement) {
        xPos = horizontalDirection * horizontalAmount * progress; // Consistent direction throughout
      }

      // Calculate rotation at this point (linear progression)
      var rotationAtProgress = rotationEnd * progress;

      keyframePositions.push({
        x: xPos,
        y: yPos,
        rotation: rotationAtProgress,
      });
    }

    // Set CSS custom properties for animation
    flake.style.setProperty("--fall-duration", fallDuration + "s");
    flake.style.setProperty("--fall-distance", fallDistance + "px");
    flake.style.setProperty("--fall-delay", fallDelay + "s");
    flake.style.setProperty("--rotation-end", rotationEnd + "deg");
    flake.style.setProperty("--sway-end", keyframePositions[8].x + "px");

    // Set keyframe positions
    for (var k = 1; k <= 8; k++) {
      var pos = keyframePositions[k];
      flake.style.setProperty("--sway-" + k, pos.x + "px");
      flake.style.setProperty("--fall-" + k, pos.y + "px");
      flake.style.setProperty("--rotation-" + k, pos.rotation + "deg");
    }

    flake.style.width = size + "px";
    flake.style.height = size + "px";
    flake.style.opacity = opacity;
    flake.style.left = startX + "%";

    // Store creation time for removal
    flake.dataset.createdAt = Date.now();
    flake.dataset.fallDuration = fallDuration;

    config.container.appendChild(flake);
    config.flakes.push(flake);

    // Remove flake after animation completes
    setTimeout(function () {
      if (flake && flake.parentNode) {
        flake.parentNode.removeChild(flake);
        var index = config.flakes.indexOf(flake);
        if (index > -1) {
          config.flakes.splice(index, 1);
        }
      }
    }, (fallDuration + fallDelay) * 1000);
  }

  function scheduleNextFlake() {
    if (!config.container) {
      return;
    }

    // Clean up flakes that are no longer in DOM
    config.flakes = config.flakes.filter(function (flake) {
      return flake && flake.parentNode;
    });

    // Only create a new flake if we're below the max
    if (config.flakes.length < config.maxFlakes) {
      createSnowflake();

      // Schedule next flake with random delay
      // Delay adjusted based on device (mobile has slower creation)
      var isMobile = theme.config.bpSmall || window.innerWidth <= 768;
      var delayMultiplier = isMobile ? 2.5 : 1;
      var nextDelay = (Math.random() * 370 + 30) * delayMultiplier;
      setTimeout(function () {
        scheduleNextFlake();
      }, nextDelay);
    } else {
      // If we're at max, check again in a bit
      setTimeout(function () {
        scheduleNextFlake();
      }, 500);
    }
  }

  function init() {
    if (!theme.settings.enableSnowflakeEffect) {
      return;
    }

    // Wait for DOM to be ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        init();
      });
      return;
    }

    config.container = document.querySelector(".snowflake-container");
    if (!config.container) {
      return;
    }

    // Position the snowflake container below the announcement bar and match header height
    var headerWrapper = document.querySelector(".header-wrapper");
    var header = document.querySelector(".site-header");
    var announcementBar =
      document.querySelector(".announcement") ||
      document.querySelector(".announcement-bar-slider");

    if (headerWrapper && header) {
      // Calculate the top position (below announcement bar if it exists)
      var topPosition = 0;

      // Set the container position and height
      config.container.style.top = topPosition + "px";

      // Match header height
      function updateContainerHeight() {
        if (header && config.container) {
          config.container.style.height = header.offsetHeight + "px";
        }
      }

      // Update height initially and on resize
      updateContainerHeight();
      window.addEventListener("resize", updateContainerHeight);

      // Also update after a short delay to account for any dynamic loading
      setTimeout(updateContainerHeight, 100);
    }

    // Get snowflake image URL
    config.snowflakeImage = theme.settings.snowflakeImageUrl;

    // Reduce density on mobile devices
    var isMobile = theme.config.bpSmall || window.innerWidth <= 768;
    var maxFlakes = isMobile
      ? Math.floor(config.maxFlakes * 0.5)
      : config.maxFlakes; // 25% on mobile (20 flakes)
    var initialFlakes = isMobile
      ? Math.min(3, maxFlakes)
      : Math.min(12, maxFlakes);
    var initialDelayRange = isMobile ? 1200 : 500;
    var nextDelayMultiplier = isMobile ? 2.5 : 1; // Much slower creation on mobile

    // Start creating flakes naturally - create first few with initial delays
    for (var i = 0; i < initialFlakes; i++) {
      setTimeout(function () {
        if (config.container && config.flakes.length < maxFlakes) {
          createSnowflake();
        }
      }, Math.random() * initialDelayRange);
    }

    // Override maxFlakes for this session
    var originalMaxFlakes = config.maxFlakes;
    config.maxFlakes = maxFlakes;

    // Start the natural flake creation cycle after a short delay
    setTimeout(function () {
      scheduleNextFlake();
    }, 500);
  }

  function destroy() {
    config.flakes.forEach(function (flake) {
      if (flake && flake.parentNode) {
        flake.parentNode.removeChild(flake);
      }
    });

    config.flakes = [];
    config.container = null;
  }

  return {
    init: init,
    destroy: destroy,
  };
})();
